import styled from "styled-components";

export const SidebarContainer = styled.aside<{ $isOpen: boolean }>`
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 280px;
  box-sizing: border-box;
  background: #ffffff;
  border-right: 1px solid var(--line);
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px 16px 16px;
  z-index: 999;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  @media (max-width: 1024px) {
    transform: translateX(${(props) => (props.$isOpen ? "0" : "-100%")});
    box-shadow: ${(props) => (props.$isOpen ? "4px 0 24px rgba(0, 0, 0, 0.15)" : "none")};
  }
`;

export const SidebarHeader = styled.div`
  padding: 0 8px 16px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const MenusWrapper = styled.div`
  flex: 0 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const Logo = styled.div`
  width: auto;
  height: 40px;
  display: flex;
  align-items: center;

  img {
    max-height: 100%;
    object-fit: contain;
  }
`;

export const LogoText = styled.span`
  font-size: 22px;
  font-weight: 700;
  background: linear-gradient(135deg, #1264C7 0%, #1E8E3E 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.5px;
`;

export const MenuSection = styled.div`
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;

  & + & {
    margin-top: 16px;
  }
`;

export const MenuTitle = styled.h3`
  font-family: var(--font-sans);
  font-size: 11px;
  font-weight: 600;
  color: #80868b;
  letter-spacing: 0.6px;
  margin: 0 0 6px 16px;
  text-transform: uppercase;
`;

export const MenuItem = styled.div<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 44px;
  padding: 0 16px;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  background: ${(props) => (props.$active ? "var(--brand-50)" : "transparent")};
  color: ${(props) => (props.$active ? "var(--brand-700)" : "var(--text)")};
  font-family: var(--font-sans);
  font-weight: 500;
  font-size: 14px;
  -webkit-tap-highlight-color: transparent;
  user-select: none;

  &:hover {
    background: ${(props) => (props.$active ? "var(--brand-50)" : "#f1f3f4")};
    color: ${(props) => (props.$active ? "var(--brand-700)" : "var(--ink)")};
  }
`;

export const MenuIcon = styled.span`
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`;

export const MenuLabel = styled.span`
  flex: 1;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const MenuBadge = styled.span`
  margin-left: auto;
  min-width: 22px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--error-bg);
  color: #b3261e;
  font-size: 11px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const SidebarFooter = styled.div`
  margin-top: auto;
  padding-top: 8px;
  flex-shrink: 0;
`;

export const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 16px;
  background: var(--bg);
  min-width: 0;
`;

export const UserAvatar = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 999px;
  background: var(--brand-50);
  color: var(--brand-700);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
`;

export const UserInfo = styled.div`
  flex: 1;
  overflow: hidden;
  min-width: 0;
`;

export const UserName = styled.div`
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const UserEmail = styled.div`
  font-size: 12px;
  color: var(--text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LogoutButton = styled.button`
  margin-left: auto;
  border: 0;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  display: inline-flex;
  padding: 6px;
  border-radius: 8px;
  flex-shrink: 0;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: var(--brand-50);
    color: var(--brand-700);
  }

  .material-icons {
    font-size: 20px;
  }
`;

export const MobileMenuButton = styled.button`
  display: none;
  position: fixed;
  top: 12px;
  left: 12px;
  z-index: 1001;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 4px 12px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  align-items: center;
  justify-content: center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #E2E6EA;
  padding: 0;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;

  &:hover {
    background: #F7F9FC;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12), 0 6px 20px rgba(0, 0, 0, 0.1);
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.98);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  }

  .material-icons {
    font-size: 24px;
    color: #1F1F1F;
    transition: color 0.2s ease;
  }

  @media (max-width: 1024px) {
    display: flex;
  }

  @media (max-width: 768px) {
    top: 12px;
    left: 12px;
    width: 44px;
    height: 44px;
    
    .material-icons {
      font-size: 22px;
    }
  }
`;

export const Overlay = styled.div<{ $isOpen: boolean }>`
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, ${(props) => (props.$isOpen ? "0.5" : "0")});
  backdrop-filter: ${(props) => (props.$isOpen ? "blur(4px)" : "blur(0)")};
  z-index: 998;
  opacity: ${(props) => (props.$isOpen ? "1" : "0")};
  visibility: ${(props) => (props.$isOpen ? "visible" : "hidden")};
  pointer-events: ${(props) => (props.$isOpen ? "auto" : "none")};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-tap-highlight-color: transparent;

  @media (max-width: 1024px) {
    display: block;
  }
`;
